import React from 'react';
import PropTypes from 'prop-types';
import { formatPhoneNumber } from '../utils/phoneNumber';

export var Tel = function Tel(_ref) {
  var className = _ref.className,
      phoneNumber = _ref.phoneNumber;

  var formattedNum = formatPhoneNumber(phoneNumber);
  return React.createElement(
    'a',
    { className: className, href: 'tel:' + formattedNum },
    formattedNum
  );
};

Tel.displayName = 'Tel';

Tel.propTypes = process.env.NODE_ENV !== "production" ? {
  phoneNumber: PropTypes.string.isRequired
} : {};

export default Tel;